import { DataType } from '@/core/data/DataType';
import { VueConstructor } from 'vue';
import { DashboardTabs } from './DashboardTabs';
import { DashboardTabWrapper } from './DashboardTabWrapper';

export function DashboardTab<T extends VueConstructor>(tabName: string, iconHtml: string, url: string, requiredTypes: DataType[], displayed: () => boolean = () => true) {
    return (ctr: T) => {
        DashboardTabs.RegisterTab(new DashboardTabWrapper(ctr, tabName, iconHtml, url, requiredTypes, displayed));
    }
}
